import * as React from 'react'
import { observer } from 'mobx-react'
import { CollectionView } from '../../collections'
import { Icon } from '../../shared/icon'
import { productStore } from '../product.store'
import './product-view-toggle.scss'

@observer
export class ProductViewToggle extends React.Component {
  render(): React.ReactNode {
    const baseClass: string = 'product-view-toggle'

    return (
      <div className={baseClass}>
        <div
          data-gtm-id={'product-view-grid'}
          className={`${baseClass}__option ${productStore.collectionView === CollectionView.GRID ? `${baseClass}__option--active` : ''}`}
          onClick={productStore.gridView}
        >
          <span><Icon icon="grid" /> Grid</span>
        </div>
        <div
          data-gtm-id={'product-view-list'}
          className={`${baseClass}__option ${productStore.collectionView === CollectionView.LIST ? `${baseClass}__option--active` : ''}`}
          onClick={productStore.listView}
        >
          <span><Icon icon="list" /> List</span>
        </div>
      </div>
    )
  }
}
